/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { BucketSchema } from './bucketSchema';
import type { EmployerBucketSchema } from './employerBucketSchema';
import type { ExperienceStatsSchema } from './experienceStatsSchema';
import type { GenderBucketSchema } from './genderBucketSchema';
import type { LocationBucketSchema } from './locationBucketSchema';
import type { TenureStatsSchema } from './tenureStatsSchema';

export interface InsightsResponseSchema {
  total_profiles: number;
  top_locations?: LocationBucketSchema[];
  top_countries?: BucketSchema[];
  experience?: ExperienceStatsSchema;
  tenure?: TenureStatsSchema;
  top_skills?: BucketSchema[];
  top_job_titles?: BucketSchema[];
  current_employers?: EmployerBucketSchema[];
  past_employers?: EmployerBucketSchema[];
  title_levels?: BucketSchema[];
  gender?: GenderBucketSchema[] | null;
  industries?: BucketSchema[];
  top_languages?: BucketSchema[];
  top_universities?: EmployerBucketSchema[];
  education_degrees?: BucketSchema[];
  top_majors?: BucketSchema[];
}
